import React from 'react';

import Link from '../Link';

const HeaderTopics = ({ topics }) => {
  return (
    <div className="" data-module-id="header_topic">
      <div className="grid grid-flow-col pt-4 pb-4 overflow-auto gap-x-4 no-scrollbar global-padding-container lg:flex lg:justify-between lg:items-center">
        {topics.length > 0 && topics.map((tag, index) => (
          <>
            <div data-component-id="header_topic_link">
              <Link
                key={tag.id}
                className="rga-topic hover:text-poppy whitespace-nowrap lg:whitespace-normal"
                to={`/${tag.type}/${tag.slug}/`}
              >
                {tag.name}
              </Link>
            </div>
            {topics.length - 1 !== index && (
              <div className="w-px h-3 transform bg-[#e5e5e5] rotate-12" />
            )}
          </>
        ))}
      </div>
      <div className="global-padding-container">
        <div className="border-b border-liquorice border-opacity-[.15]" />
      </div>
    </div>
  );
};

export default HeaderTopics;
